export default "__VITE_ASSET__C1YYind7__"